import React, { useEffect, useState } from 'react';
import { GenesysDevIcon, GenesysDevIcons } from 'genesys-dev-icons';

import Tooltip from '../tooltip/Tooltip';
import { isSubscriptionAllowed, toggleSubscription, useSubscriptions } from '../../helpers/atoms/SubscriptionsAtom';
import { NotificationMode, TopicKey } from '../../helpers/CmsApiTypes';
import CmsApi from '../../helpers/CmsApi';
import { addToast, ToastType } from '../../helpers/atoms/ToastAtom';

import './SubscribeIcon.scss';

interface IProps {
	pagePath: string;
	className?: string;
}

export default function SubscribeIcon(props: IProps) {
	const subscriptions = useSubscriptions();
	const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
	const [isTooltipActive, setIsTooltipActive] = useState<boolean>(false);
	const [allowSubscriptions, setAllowSubscriptions] = useState<boolean>(true);

	useEffect(() => {
		setIsSubscribed(
			subscriptions[TopicKey.YetiCmsPublishPath]?.some((s) => s.params['keyPath'] === normalizePath(props.pagePath)) || false
		);
		setIsTooltipActive(false);
		isSubscriptionAllowed(props.pagePath).then(setAllowSubscriptions);
	}, [subscriptions, props.pagePath]);

	// Remove component if subscriptions are not allowed
	if (!allowSubscriptions) {
		return <></>;
	}

	const onClick = () => {
		if (!CmsApi.currentUser) {
			// This should only happen for the dev center, so assume the /publiclogin URL
			addToast({
				title: 'Login required',
				message: 'You must be logged in to subscribe to page updates',
				toastType: ToastType.Warning,
				timeoutSeconds: 30,
				link: '/publiclogin',
				linkText: 'Sign In',
			});
			return;
		}

		toggleSubscription(
			`yeti-cms.${process.env['REACT_APP_SITE_PROPERTY']}.publish.path.${normalizePath(props.pagePath)}`,
			NotificationMode.DigestDaily
		);

		// Update state
		setIsSubscribed(!isSubscribed);

		// Tooltip control
		setIsTooltipActive(true);
		setTimeout(() => setIsTooltipActive(false), 1000);
	};

	return (
		<Tooltip
			text={isSubscribed ? 'Subscribed' : 'Unsubscribed'}
			className={`subscribe-icon-container ${props.className || ''}`}
			isShowing={isTooltipActive}
			position="right"
		>
			<GenesysDevIcon
				className={`subscribe-icon${isSubscribed ? ' subscribe-icon-active' : ''}`}
				onClick={onClick}
				icon={isSubscribed ? GenesysDevIcons.AppNotificationsSolid : GenesysDevIcons.AppNotifications}
			/>
		</Tooltip>
	);
}

function normalizePath(p: string) {
	// Web links do not include "index", but the keypaths used in notifications do
	if (p.endsWith('/')) p += 'index';
	return p;
}
